import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    position: "relative",
  },
  dialog: {
    marginTop: 5,
    marginLeft: 5
  },
  backButton: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.4
    }
  },
  span: {
    border: '1px solid rgba(25, 113, 140,1)', 
    padding: 3, 
    fontSize: 11, 
    color: 'rgba(25, 113, 140, 1)', 
    backgroundColor: 'rgba(25, 113, 140, 0.1)', 
    borderRadius: 3,
     marginLeft: 5, 
     userSelect: 'none'
  },
  spanImprimir: {
    border: '1px solid rgba(25, 113, 140,1)', 
    padding: 3, 
    fontSize: 11, 
    color: 'rgba(25, 113, 140, 1)', 
    borderRadius: 3,
     marginLeft: 5, 
     userSelect: 'none'
  },
  bodyAppBar: {
    flexGrow: 1, 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    paddingTop: 10, 
    paddingBottom: 10
  },
  rootAppBar: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  appBar: {
    backgroundColor: 'rgba(66, 66, 66, 1)'
  },
  title: {
    flex: 1
  },
});
